export const breakPoints = {
  small: 480,
  medium: 768,
  large: 1024,
};
